import { Link } from "react-router-dom";
import { useAuth } from "../../stores/auth";
import { socialLinks } from "./socialLinks";

const LEGAL_LINKS = [
  { slug: "terms", label: "Terms" },
  { slug: "privacy", label: "Privacy" },
  { slug: "refund", label: "Refunds" },
  { slug: "shipping", label: "Shipping" },
];

export function SiteFooter() {
  const config = useAuth((s) => s.config);
  const links = socialLinks(config?.social, config?.whatsappUrl);
  const storeName = config?.storeName || "Mr Gaole";

  return (
    <footer className="mt-10 border-t border-white/10 px-4 pb-6 pt-6 lg:px-8">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center gap-4 text-center lg:flex-row lg:justify-between lg:text-left">
        <div>
          <p className="font-display text-sm font-bold text-white">{storeName}</p>
          <p className="mt-0.5 text-[11px] text-white/40">
            © {new Date().getFullYear()} {storeName}. All rights reserved.
          </p>
        </div>

        <nav aria-label="Legal" className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-white/50">
          {LEGAL_LINKS.map((l) => (
            <Link key={l.slug} to={`/legal/${l.slug}`} className="transition-colors hover:text-white">
              {l.label}
            </Link>
          ))}
        </nav>

        {links.length > 0 && (
          <div className="flex items-center gap-2">
            {links.map((link) => (
              <a
                key={link.key}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                title={link.label}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/70 transition-colors hover:border-brand-pink/50 hover:text-white"
              >
                <link.Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        )}
      </div>
    </footer>
  );
}
